import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class KnowledgeCacheService {
  private invalidatedSubject = new Subject<void>();
  readonly invalidated$: Observable<void> = this.invalidatedSubject.asObservable();

  invalidate(): void {
    this.invalidatedSubject.next();
  }
}
